export const padding = {
  top: 0,
  bottom: 48,
};
